module.exports = __webpack_public_path__ + "static/img/process_not_register_bg.ace97bba.png";